import {fetchDataPromises} from '../../scheduling_fetch';
import DirectApi from '../../../../directApi';

export const fetchAutoSchedulingData = () => {
	let requestUrl = DirectApi.graphqlServerEndpoint('scheduling/autoSchedulingData');
	return fetchDataPromises([{url: requestUrl, method: 'GET'}]);
};
